/**
 * Boards of area (h) — tech. OWNED BY area (h) — tech (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const techBoards: BoardDef[] = [
  {
    id: "TD-Console",
    ref: "TD1",
    title: "Technique — Console CTO · debug",
    area: "tech",
    path: "/technique",
    href: "/technique",
    permission: ["tech.console", "read"],
    persona: "cto",
    kind: "page",
    note: "CTO écrit, DEV lit, RSSI 403. Jobs pg-boss réels (23), webhook_events, platform_features.",
    nav: "tech.console",
    space: "technique",
    component: lazy(() => import("./boards/TD-Console")),
  },
  {
    id: "TD-Developpeurs",
    ref: "TD2",
    title: "Technique — Développeurs Melrys",
    area: "tech",
    path: "/technique/developpeurs",
    href: "/technique/developpeurs",
    permission: ["tech.developers", "read"],
    persona: "cto",
    kind: "page",
    note: "CTO écrit, DEV lit. Fournisseurs sandbox / live, variables « configuré » seulement, email_outbox.",
    nav: "tech.developpeurs",
    space: "technique",
    component: lazy(() => import("./boards/TD-Developpeurs")),
  },
  {
    id: "TD-RSSI",
    ref: "TD3",
    title: "Technique — RSSI Melrys",
    area: "tech",
    path: "/technique/rssi",
    href: "/technique/rssi",
    permission: ["tech.security", "read"],
    persona: "rssi",
    kind: "page",
    note: "RSSI écrit, CTO lit, DEV 403. users / sessions / auth_login_locks.",
    nav: "tech.rssi",
    space: "technique",
    component: lazy(() => import("./boards/TD-RSSI")),
  },
];
